/**
 * Formats a price value into PLN currency string.
 * @param {number|string} price - The price to format.
 * @returns {string} Formatted price string (e.g. "123 456") or "Zapytaj" if null/0.
 */
export const formatPrice = (price) => {
    if (!price) return "Zapytaj";
    return parseFloat(price).toLocaleString('pl-PL');
};

/**
 * Formats a mileage value into km string.
 * @param {number|string} mileage - The mileage in km.
 * @returns {string} Formatted string (e.g. "123 456 km") or "-" if null.
 */
export const formatMileage = (mileage) => {
    if (!mileage) return "-";
    return `${parseInt(mileage).toLocaleString('pl-PL')} km`;
};

/**
 * Maps technical keys to human-readable Polish labels.
 * @param {string} value - The raw value from API.
 * @param {string} type - The type of value ('transmission', 'body_type', 'fuel_type').
 * @returns {string} Human readable label.
 */
export const getLabel = (value, type) => {
    if (!value) return "-";

    if (type === 'transmission') {
        const map = {
            'automatic': 'Automatyczna',
            'manual': 'Manualna'
        };
        return map[value] || value;
    }

    if (type === 'body_type') {
        const map = {
            'sedan': 'Sedan',
            'coupe': 'Coupe',
            'suv': 'SUV',
            'kombi': 'Kombi',
            'hatchback': 'Hatchback',
            'cabrio': 'Kabriolet',
            'van': 'Van',
            'minivan': 'Minivan',
            'pickup': 'Pickup'
        };
        return map[value] || value;
    }

    if (type === 'fuel_type') {
        // Simple capitalization for now, can be expanded
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    return value;
};
